export default __webpack_public_path__ + "static/tek_img_04-df7c51cd09041652dac96001c9734593.webp";